































import { Vue, Component, PropSync, Ref } from 'vue-property-decorator';
import RadioGroup from '@/pro/components/common/RadioGroup.vue';
import { getOnlyNumbers } from '@/pro/utils/numberFormat';

import { RadioBoxGroupOption } from '@/pro/helpers/type';
import { YorN } from 'ncp-api-supporter';
import { BuyInfo } from '@/pro/types';
import TextInput from '@/pro/components/common/input/TextInput.vue';

@Component({
  components: {
    TextInput,
    RadioGroup,
  },
})
export default class MinPurchaseQuantity extends Vue {
  @PropSync('buyInfo', { required: false })
  private buyInfoSync: BuyInfo;
  @PropSync('minBuyCount')
  private minBuyCountSync!: number;

  @Ref()
  private readonly inputRef: TextInput;
  public focus() {
    this.inputRef.focus();
  }

  private disabled = false;
  private validation = {
    text: '',
    onlyNumber: 'STOCK.MANAGEMENT.INPUT_NUMBER_ERROR',
    rangeNumber: 'PRODUCT_ADD_INPUTABLE_RANGE',
  };

  private radioOption: RadioBoxGroupOption<YorN> = {
    name: 'usePurchaseMin',
    data: [
      { id: 'notAllowedMinPurchaseMin', value: 'N', display: 'PRO_PRODUCT_COMMON_NOT_USE' },
      { id: 'allowedMinPurchaseMin', value: 'Y', display: 'PRO_PRODUCT_COMMON_USE' },
    ],
  };

  private changedUseMinPurchaseStatus(curr: YorN) {
    if (curr === 'Y') this.validation.text = '';
  }

  private handleOnlyNumber({ target }: { target: HTMLInputElement }) {
    const { value } = target;

    this.minBuyCountSync = getOnlyNumbers(value);
    this.validation.text = '';
  }

  private checkMinQuantity({ target }: { target: HTMLInputElement }) {
    const minQuantityCriteria = 2;
    if (Number(target.value) < minQuantityCriteria) {
      this.validation.text = this.validation.rangeNumber;
      return;
    }
    this.validation.text = '';
  }
}
